import { render, staticRenderFns } from "./UserEditPreviousStudies.vue?vue&type=template&id=6000c3c7"
import script from "./UserEditPreviousStudies.vue?vue&type=script&lang=js"
export * from "./UserEditPreviousStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports